import React from "react";
import { Global, InfoCircle } from "iconsax-react";

import MobileLayout from "../../components/MobileLayout";
import Logo from "../../assets/images/adaptive-icon.png";

import {
  Body,
  Card,
  CardTitle,
  Text,
  LogoRow,
  PrimaryLink,
  InpiRow,
  InesBadge,
} from "./styles";

const BILINGUA_WEB = "https://www.bilinguahub.com.br/";
const INES_WEB =
  "https://www.gov.br/ines/pt-br/acesso-a-informacao-1/institucional/conheca-o-ines";
const INPI_MARCA =
  "https://busca.inpi.gov.br/pePI/servlet/MarcasServletController?Action=detail&CodPedido=5786940";

const AboutPage: React.FC = () => {
  return (
    <MobileLayout
      headerTitle="Sobre o App"
      headerType="private"
      headerDescription="Bilíngua HUB e parceiros"
    >
      <Body>
        <Card>
          <LogoRow>
            <img src={Logo} alt="Bilíngua" />
            <div>
              <CardTitle style={{ marginBottom: 4 }}>Bilíngua HUB</CardTitle>
              <Text style={{ marginBottom: 0 }}>
                A Bilíngua HUB é uma plataforma dedicada ao aprendizado e ao
                ensino da Língua Brasileira de Sinais (Libras), promovendo
                inclusão e acessibilidade.
              </Text>
            </div>
          </LogoRow>
          <Text>
            Nossos recursos incluem sinalário, jogos educativos, assistente de
            IA e notícias sobre Libras, pensados para surdos e ouvintes que
            desejam aprender ou aprofundar o conhecimento em Libras.
          </Text>
          <PrimaryLink href={BILINGUA_WEB} target="_blank" rel="noreferrer">
            <Global size={20} variant="Bold" color="#5F33E1" />
            Visite nosso site
          </PrimaryLink>
          <InpiRow href={INPI_MARCA} target="_blank" rel="noreferrer">
            <span>Bilíngua HUB®</span>
            <InfoCircle size={16} variant="Linear" />
            <span>Marca registrada no INPI</span>
          </InpiRow>
        </Card>

        <Card>
          <CardTitle>Sobre o Sinalário</CardTitle>
          <Text>
            O Sinalário de Libras é o aplicativo da Bilíngua HUB para consulta e
            aprendizado de sinais em Libras, com milhares de verbetes, vídeos e
            busca por letra.
          </Text>
          <Text>
            Você pode favoritar sinais, acessar jogos educativos, usar o
            assistente de IA para tirar dúvidas e acompanhar notícias sobre
            Libras, sempre com foco em acessibilidade.
          </Text>
        </Card>

        <Card>
          <LogoRow>
            <InesBadge>INES</InesBadge>
            <div>
              <CardTitle style={{ marginBottom: 4 }}>Sobre o INES</CardTitle>
            </div>
          </LogoRow>
          <Text>
            O INES — Instituto Nacional de Educação de Surdos — é referência
            nacional na educação de pessoas surdas. Foi fundado em 26 de
            setembro de 1857 no Rio de Janeiro pelo educador francês Ernest Huet
            e é a primeira escola para surdos da América Latina.
          </Text>
          <Text>
            Oferece educação bilíngue em Libras e Língua Portuguesa, da educação
            infantil à pós-graduação, além de cursos gratuitos de Libras e a TV
            INES, primeira webTV em Língua Brasileira de Sinais.
          </Text>
          <Text>
            O Sinalário de Libras conta com a parceria e o apoio do INES na
            divulgação e no fortalecimento da Libras.
          </Text>
          <PrimaryLink href={INES_WEB} target="_blank" rel="noreferrer">
            <Global size={20} variant="Bold" color="#5F33E1" />
            Acessar site do INES
          </PrimaryLink>
        </Card>
      </Body>
    </MobileLayout>
  );
};

export default AboutPage;
